import { useRef } from 'react'

/**
 * While a bot answer is streaming, keep returning the last committed value
 * so suggestion strips stay static until phase-2 metadata lands.
 */
export function useFrozenWhileStreaming(value, isStreaming) {
  const ref = useRef(value)
  if (!isStreaming) ref.current = value
  return isStreaming ? ref.current : value
}
